module.exports = "/fonts/Rubik-Regular.ttf?cd619a4f068dc66cc6e58fe0a91a8a34";